import { render, staticRenderFns } from "./RDMCredentialsInfo.vue?vue&type=template&id=c2ae3e4c"
import script from "./RDMCredentialsInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./RDMCredentialsInfo.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports